import {ReactNode} from "@tanstack/react-router";
import {ButtonHTMLAttributes} from "react";
import {ButtonVariants, button} from "./index.css";

export type ButtonProps = {children: ReactNode | ReactNode[]} & ButtonHTMLAttributes<HTMLButtonElement> & ButtonVariants;

function Button({fullWidth, size, children, color, ...rest}: ButtonProps) {
	return (
		<button type={"button"} className={button({fullWidth, size, color})} {...rest}>
			{children}
		</button>
	);
}

export default Button;
